@let isUnauthorizedReportLoading = reportsService.reportProcessingStatus === 'processing' && accessService.isUnauthorized;


<mat-nav-list class="navigation-menu-panel" *ngIf="!(breakpointObserverService.isMobile | async)" [ngClass]="isUnauthorizedReportLoading ? 'unauthorized-report-loading' : ''">
  <app-icon svgIcon="logo" class="logo-icon" routerLink="/"></app-icon>

  <div class="desktop-pointer">
<!--    <app-icon svgIcon="pointer"></app-icon>-->
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank" matTooltip="Home" matTooltipPosition="right">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink
       [routerLink]="isUnauthorizedReportLoading ? null : '/'"
       [class.active-link]="isActiveWithQueryParams('/')"
       matTooltip="Explore the interactive map"
       matTooltipPosition="right"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="home"
      ></app-icon>
      <span>Home</span>
    </a>

    <a #navLink
       [routerLink]="'chat'"
       matTooltip="Ask AI about any location"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="ai_chat"
      ></app-icon>
      <span>AI Chat</span>

    </a>

    <a #navLink
       [routerLink]="'reports'"
       matTooltip="Download a full location analysis as PDF"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="report"
      ></app-icon>
      <span>Order report</span>

    </a>

    <a #navLink
       [routerLink]="isUnauthorizedReportLoading ? null : 'comparative-location-tool'"
       matTooltip="Side-by-side comparison of multiple locations"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="comparative-location"
      ></app-icon>
      <span>Compare locations</span>
    </a>

    <a #navLink
       [routerLink]="isUnauthorizedReportLoading ? null : 'info'"
       matTooltip="See what data powers the map"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="help"
      ></app-icon>
      <span>Data sources</span>
    </a>
  </div>

  <div class="user-icon-container">
    <a *ngIf="accessService.getIsAdmin(); else getDemo"
       #navLink
       [routerLink]="'admin'"
       matTooltip="Manage users and platform settings" matTooltipPosition="right"
    >
      <app-icon
        routerLinkActive="active-link"
        svgIcon="adminPanel"
        class="admin-icon"
      ></app-icon>
    </a>
    <a #navLink class="user-icon-circle" routerLinkActive="active-link" [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" [matTooltip]="authService.hasAccessToken() ? 'Manage your subscription and account' : 'Log in to access premium features'" matTooltipPosition="right">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        class="user-icon"></app-icon>
    </a>
  </div>
</mat-nav-list>

<nav class="navigation-menu-panel-mobile" *ngIf="breakpointObserverService.isMobile | async"  [ngClass]="isUnauthorizedReportLoading ? 'unauthorized-report-loading' : ''">
  <!-- Single sliding pointer for mobile -->
  <div class="mobile-pointer">
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink [routerLink]="isUnauthorizedReportLoading ? null : '/'">
      <app-icon
        svgIcon="home"
        [class.active-link]="isActiveWithQueryParams('/')"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'chat'" class="user-icon">
      <app-icon
        [svgIcon]="'ai_chat'"
        [class.active-link]="isActiveWithQueryParams('/chat')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" class="user-icon">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        [class.active-link]="isActiveWithQueryParams('/user')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a *ngIf="accessService.getIsAdmin()"
       #navLink
       [routerLink]="'/admin'">
      <app-icon
        svgIcon="adminPanel"
        routerLinkActive="active-link"
        class="admin-icon"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="isUnauthorizedReportLoading ? null : '/comparative-location-tool'">
      <app-icon
        svgIcon="comparative-location"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'/reports'">
      <app-icon
        svgIcon="report"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="isUnauthorizedReportLoading ? null : '/info'">
      <app-icon
        svgIcon="help"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>
  </div>
</nav>

<ng-template #getDemo>
  <a class="get-demo-link"
     matTooltip="Schedule a call"
     matTooltipPosition="right"
     href='https://calendly.com/astepanyan-1/15-minute-intro-call'
     target="_blank"
  >Get <br>
    a demo
  </a>
</ng-template>
